import {adminAxios} from '@/Plugins/Axios';

// Daily-creation (revenue) report: bills / freight / goods value / boxes per
// day, hour, express|logistics, origin branch and pay type. Lives under
// /api/admin — adminAxios' own baseURL. Pass `branch_id` for the branch drill.
export async function fetchCreationSummaryReport(params = {}) {
    const response = await adminAxios.get('report/creation-summary', {params});
    return response.data.data;
}
